'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024proto$0024$002dLogoff$002dResponse from "./presto.types$proto$-Logoff-Response.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$LogoffResponse$() {
}
export { $c_Lpresto_types$proto$LogoffResponse$ as $c_Lpresto_types$proto$LogoffResponse$ };
$p = $c_Lpresto_types$proto$LogoffResponse$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$LogoffResponse$;
/** @constructor */
function $h_Lpresto_types$proto$LogoffResponse$() {
}
export { $h_Lpresto_types$proto$LogoffResponse$ as $h_Lpresto_types$proto$LogoffResponse$ };
$h_Lpresto_types$proto$LogoffResponse$.prototype = $p;
$p.l = (function() {
  return "LogoffResponse";
});
$p.cGP = (function(x$0) {
  return new $j_presto$002etypes$0024proto$0024$002dLogoff$002dResponse.$c_Lpresto_types$proto$LogoffResponse((!(!x$0.j(0))));
});
var $d_Lpresto_types$proto$LogoffResponse$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$LogoffResponse$, "presto.types$proto$LogoffResponse$", ({
  a3g: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$proto$LogoffResponse$ as $d_Lpresto_types$proto$LogoffResponse$ };
var $n_Lpresto_types$proto$LogoffResponse$;
function $m_Lpresto_types$proto$LogoffResponse$() {
  if ((!$n_Lpresto_types$proto$LogoffResponse$)) {
    $n_Lpresto_types$proto$LogoffResponse$ = new $c_Lpresto_types$proto$LogoffResponse$();
  }
  return $n_Lpresto_types$proto$LogoffResponse$;
}
export { $m_Lpresto_types$proto$LogoffResponse$ as $m_Lpresto_types$proto$LogoffResponse$ };
//# sourceMappingURL=presto.types$proto$-Logoff-Response$.js.map
